import { formatEntityName, formatFieldName, formatRoleName } from '../../../common';
import { createSchemaStatementHandler } from '../../createSchemaStatementHandler';
import { buildOperations, validateRole } from '../../utils';
export const aclAllowFieldsStmtInstruction = `
#### Allowing access to fields in entities
- Syntax: \`allow <roleName1>[, <fieldName2>] to <accessTypes> entity <entityName> fields <field1>[, <field2>];\`
- Example: \`allow public to read entity Article field title, content;\`
- Example: \`allow editor to read, create, update entity Article field title, content;\`
- Example: \`allow public, editor to read entity Article field title, content;\`
`;
export const stmtAclAllowFields = ({ roleNames, accessTypes, entityName, fieldNames }) => {
    return `allow ${roleNames.join(', ')} to ${accessTypes.join(', ')} entity ${entityName} fields ${fieldNames.join(', ')};`;
};
export const stmtForHumanAclAllowFields = ({ roleNames, accessTypes, entityName, fieldNames }) => {
    return `Allow the roles __${roleNames.join(', ')}__ to ${accessTypes.join(', ')} the fields __${fieldNames.join(', ')}__ of the entity __${entityName}__.`;
};
export const aclAllowFieldsHandler = createSchemaStatementHandler({
    type: 'allow field',
    parse: line => {
        const match = /^allow (?<roleNames>[\w, ]+) to (?<accessType>[\w, ]+) entity (?<entityName>\w+) fields? (?<fieldNames>[\w, ]+)/.exec(line);
        return match?.groups
            ? {
                type: 'allow field',
                roleNames: match.groups.roleNames.split(',').map(it => formatRoleName(it.trim())),
                accessTypes: match.groups.accessType
                    .split(', ')
                    .map(item => item.trim())
                    .filter((it) => ['create', 'update', 'read'].includes(it)),
                entityName: formatEntityName(match.groups.entityName),
                fieldNames: match.groups.fieldNames?.split(',').map(item => formatFieldName(item.trim())),
            }
            : null;
    },
    getHumanStmt: stmtForHumanAclAllowFields,
    apply: (stmt, builder) => {
        builder.updateSchema(it => {
            const entity = it.schema.model.entities[stmt.entityName];
            if (!entity) {
                throw new Error(`Entity ${stmt.entityName} does not exist`);
            }
            let updatedSchema = it;
            for (const roleName of stmt.roleNames) {
                validateRole(roleName);
                if (stmt.fieldNames.some(fieldName => !entity.fields[fieldName])) {
                    throw new Error(`Field ${stmt.fieldNames.find(fieldName => !entity.fields[fieldName])} does not exist in entity ${stmt.entityName}`);
                }
                const operations = buildOperations({ entity, fieldNames: stmt.fieldNames, accessTypes: stmt.accessTypes, predicate: true });
                updatedSchema = updatedSchema.createAclRole(roleName).updatePermissionsEntity(roleName, stmt.entityName, {
                    predicates: {},
                    operations,
                });
            }
            return updatedSchema;
        });
    },
});
//# sourceMappingURL=AclAllowFieldsStmt.js.map